import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ChannelState } from "./channel.models";

export const selectChannelState = createFeatureSelector<ChannelState>('channel');

export const selectChannel = createSelector(
  selectChannelState,
  state => state.data
);

export const selectAllChannels = createSelector(
  selectChannelState,
  state => state.allData
);

export const selectChannelError = createSelector(
  selectChannelState,
  state => state.error
);

export const selectChannelMessage = createSelector(
  selectChannelState,
  state => state.message
);

export const selectChannelSuccess = createSelector(
  selectChannelState,
  state => state.success
);

export const selectChannelValidationError = createSelector(
  selectChannelState,
  state => state.validationError
);